import Vue from 'vue'
Vue.mixin({
    mounted () {
        ///////////////////////////////////////////////////////////////////////////
        // Input
        window.$(".clear-input").click(function () {
            window.$(this).parent(".input-wrapper").find(".form-control").focus();
            window.$(this).parent(".input-wrapper").find(".form-control").val("");
            window.$(this).parent(".input-wrapper").removeClass("not-empty");
        });
        // active
        window.$(".form-group .form-control").focus(function () {
            window.$(this).parent(".input-wrapper").addClass("active");
        }).blur(function () {
            window.$(this).parent(".input-wrapper").removeClass("active");
        })
        // empty check
        window.$(".form-group .form-control").keyup(function () {
            var inputCheck = window.$(this).val().length;
            if (inputCheck > 0) {
                window.$(this).parent(".input-wrapper").addClass("not-empty");
            } else {
               window.$(this).parent(".input-wrapper").removeClass("not-empty");
            }
        });
    }
})